// extracted by mini-css-extract-plugin
module.exports = {"sticky_footer":"Bottom_sticky_footer__37YIs","connect":"Bottom_connect__ROHnf","links":"Bottom_links__1EJWv"};